import { EventEmitter, Output } from "@angular/core";
import { MatSelectionList } from "@angular/material/list";
import { FilterItem, IFilterItem } from "./ifilteritem.model";

export interface IFilterItemCollection {
  id_filter: string;
  items: IFilterItem[];
  value: any[];
  selected:any[];
}

export class FilterItemCollection implements IFilterItemCollection {
  id_filter: string;
  items: IFilterItem[] = [];
  value: any[]=[];
  selected:any[]=[];

  constructor(id_filter: string) {
    this.id_filter = id_filter;
  }

  /**
   * Add items from a list
   * @param fieldID field to use as id of the object
   * @param fieldViewName field to use as viewname of the object
   * @param list 
   */
  addItems(fieldID: string, fieldViewName: string, list: any[]) {

    for (let elem of list) {
      let item = new FilterItem();
      item.value = elem;
      item.id = elem[fieldID];
      item.viewname = elem[fieldViewName];
      this.items.push(item);
    }
    this.value=list;
    this.selected=this.items;
  }

  /**
   * Add items from a plain list
   * @param list plain list
   */
  addItemsByList(list: any[]) {
    for (let elem of list) {
      let item = new FilterItem();
      item.value = elem;
      item.id = elem;
      item.viewname = elem;
      this.items.push(item);
    }
    this.value=list;
    this.selected=this.items;
  }

  addItemsByFilterItemList(list: FilterItem[]) {
    this.items=list;    
    this.value=list;
    this.selected=this.items;
  }


}

export class GenFilter {
  filtersList: IFilterItemCollection[]=[];
  //@Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();

  addFilter(filter: IFilterItemCollection) {
    this.filtersList.push(filter);
  }

  filterGet(filterName: string):IFilterItemCollection {
    let f: any = this.filtersList.find(item => item.id_filter == filterName);
    if (!f) {
      f = [];
    }
    return f;
  }

  getIDBFilter():IFilterItemCollection[] {
    let elemSelected:IFilterItemCollection[]  = [];

    for (let item of this.filtersList){
      elemSelected.push(...this.selectionGetSelected(item.id_filter,item.selected));
    }

    return elemSelected;
  }


  private selectionGetSelected(id_filter: string, selectedItems: IFilterItem[]):IFilterItemCollection[] {
    let elemSelected: IFilterItemCollection[]=[];
    if (selectedItems && selectedItems.length > 0) {
      let selected:IFilterItem[] = selectedItems;
      let filterItemCol = new FilterItemCollection(id_filter);
      if (selected) {
        //filterItemCol.addItemsByFilterItemList(selected);
        for (let elem of selected) {
          let item :FilterItem= elem;
          filterItemCol.items.push( item);
          filterItemCol.value.push (item.value);
           filterItemCol.selected.push(item);
        }
      }
      
      elemSelected.push(filterItemCol);
    }
    return elemSelected;

  }
}